module.exports = __webpack_public_path__ + "static/media/image.4f690173.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/UX/image.png
// module id = 81
// module chunks = 0